import { UploadComplete } from './upload-complete';

export default UploadComplete;
